export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14690.6a0b347f.jpg";